<div class="svg-loader" *ngIf="isLoading"></div>
<div class="largeModelContainer" *ngIf="!isLoading">
  <div class="">
    <a class="cancelBtn cancelBtnPosn" (click)="onCancelClick()"></a>
  </div>
  <div class="modelTitle alignCenter ">
    Workflow scheduler
  </div>
  <div class="modelBody">
    <form [formGroup]="schedulerForm">
      <div class="pad-lr">
        <div class="form-group row">
          <label for="workflowTriggerTypeId" class="col-4 mt-2 largeText mandatory-field">Workflow Trigger</label>
          <div class="col-8">
            <select id="workflowTriggerTypeId" (change)="onWorkflowTriggerSelected($event)" class="form-control select-btn" required formControlName="workflowTriggerTypeId">
              <option *ngFor="let element of workflowTriggerList" [ngValue]="element.timerTypeId">{{element.timerTypeVal}}</option>
            </select>
          </div>
        </div>
        <div class="form-group row" *ngIf="globalService.isNotNullObject(workflowTriggerList) && schedulerForm.get('workflowTriggerTypeId').value==workflowTriggerList[0].timerTypeId">
          <label for="frequency" class="col-4 mt-2 largeText mandatory-field">Frequency</label>
          <div class="col-4">
            <input id="frequency" type="text" class="form-control select-btn" required formControlName="frequency" (change)="onDurationTypeSelected($event)" autocomplete="off" />
          </div>
          <div class="col-4">
            <select id="frequencyUnitId" (change)="onDurationTypeSelected($event)" class="form-control select-btn" required formControlName="frequencyUnitId">
              <option *ngFor="let element of durationTypesList" [ngValue]="element.frequencyUnitId">{{element.frequencyUnitValue}}</option>
            </select>
          </div>
        </div>
        <div class="form-group row" *ngIf="globalService.isNotNullObject(workflowTriggerList) && schedulerForm.get('workflowTriggerTypeId').value==workflowTriggerList[1].timerTypeId">
          <label for="dataSourceId" class="col-4 mt-2 largeText mandatory-field">Data Source</label>
          <div class="col-8">
            <select id="dataSourceId" (change)="onDurationTypeSelected($event)" class="form-control select-btn" required formControlName="dataSourceId">
              <option *ngFor="let element of dataSourceList" [ngValue]="element.datasourceId">{{element.datasourceName}}</option>
            </select>
          </div>
        </div>
        <div class="form-group row">
          <label for="startTime" class="col-4 mt-2 mandatory-field">Start Time</label>
          <div class="col-8">
            <input id="startTime" formControlName="startTime" [owlDateTime]="dt1" [owlDateTimeTrigger]="dt1" autocomplete="off"
                   placeholder="From" class="form-control mb-1" (dateTimeInput)="startTimeChange()" (dateTimeChange)="updateEndDate(dt1)" />
            <owl-date-time #dt1></owl-date-time>
          </div>
        </div>
        <div class="form-group row" *ngIf="this.schedulerForm.get('startTime').value && displayEndTime()">
          <label for="endTime" class="col-4 mt-2 mandatory-field largeText">End Time</label>
          <div class="col-8">
            <input id="endTime" formControlName="endTime" [owlDateTime]="dt2" [owlDateTimeTrigger]="dt2" autocomplete="off"
                   placeholder="To" class="form-control mb-1" [min]="toMinDt" [max]="toMaxDt"/>
            <owl-date-time #dt2></owl-date-time>
          </div>
        </div>
      </div>
    </form>
    <div class="d-flex alignCenter">
      <button id="createBtn" type="submit" class="saveBtn2 primaryBtn" (click)="saveSchedulerDetails()" [disabled]="disableAddBtn() || readOnly">Save</button>
    </div>
  </div>
</div>
